import React from 'react';
import PropTypes from 'prop-types';

// share dependencies
import localizer from 'share/localization/Izenda.Localizer';
const previousStep = -1;
/**
 * @function NLQNav
 * @description returns NLQ navigational tabs
 * @param {object} props component properties
 */
function NLQNav(props) {
  const { activeTab, onActiveTab, isResult } = props;
  const tabs = localizer.getText('EXPLORE_NAV');

  return (
    <nav className='nav explore-nav-wrapper'>
      {isPrevousLinkShow(isResult, activeTab, tabs) && (
        <button className='btn btn-link btn-link-left' onClick={navigateBackard.bind(this, props)}>
          <i className='icon-left explore-nav-back-icon'></i>
        </button>
      )}
      <div className='explore-nav'>
        {Object.values(tabs).map(({ order, title }) => (
          <div
            className={
              activeTab === order
                ? 'tab-active tab-visited tab-list'
                : `tab-list ${getActiveName(order, isResult, activeTab, tabs)}`
            }
            data-toggle='tab'
            key={order}
            onClick={onActiveTab.bind(this, order)}
          >
            <span className='breadcrumb-indicator'>{order}</span>
            <span className='round-tabs'>{title}</span>
          </div>
        ))}
      </div>
      {isRightLinkShow(isResult, activeTab, tabs) && (
        <button className='btn btn-link btn-link-right' onClick={navigateForward.bind(this, props)}>
          <i className='icon-left explore-nav-back-icon'></i>
        </button>
      )}
    </nav>
  );
}

function getActiveName(order, isResult, activeTab, tabs) {
  let activeTabVisited = '';
  if (
    order === tabs.ask.order ||
    (activeTab === tabs.results.order) === order ||
    (isResult && order == tabs.vis.order) ||
    (isResult && order == tabs.results.order)
  )
    activeTabVisited = 'tab-visited';
  return activeTabVisited;
}

function isPrevousLinkShow(isResult, activeTab, tabs) {
  let isPrevousLinkShow = false;
  if (activeTab === tabs.results.order || activeTab === tabs.vis.order) isPrevousLinkShow = true;
  return isPrevousLinkShow;
}

function isRightLinkShow(isResult, activeTab, tabs) {
  let isPrevousLinkShow = false;
  if (isResult && activeTab === tabs.results.order) isPrevousLinkShow = true;
  return isPrevousLinkShow;
}

function navigateForward(props) {
  props.onActiveTab(3);
}
function navigateBackard(props) {
  props.onActiveTab(props.activeTab - 1);
}
/**
 * @property propTypes
 * @description property types for NLQNav
 * @type {number} activeTab: a digit that represents the current tab
 * @type {function} onActiveTab: a callback for when the user clicks a tab
 */
NLQNav.propTypes = {
  activeTab: PropTypes.number.isRequired,
  onActiveTab: PropTypes.func.isRequired
};

export default NLQNav;



// WEBPACK FOOTER //
// ./ui/modules/Explore/Header/Izenda.NLQNav.js